import { render, staticRenderFns } from "./RunsTable.vue?vue&type=template&id=5d5f06fe&scoped=true&"
import script from "./RunsTable.vue?vue&type=script&lang=ts&"
export * from "./RunsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RunsTable.vue?vue&type=style&index=0&id=5d5f06fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f06fe",
  null
  
)

export default component.exports